import React from 'react';
import { TransactionNotesProps } from './transaction-notes.types';
import { TransactionContext, TransactionContextType } from '@/app/report/transactions/context';
import { useContext, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import './transaction-notes.style.scss';
import { Textarea } from '@/components/ui/textarea';

const TransactionNotes: React.FC<TransactionNotesProps> = ({ onChange }) => {

    const { selectedTransaction } = useContext(TransactionContext) as TransactionContextType; 
    const [selectedNote, setSelectedNote] = React.useState<string | null>(selectedTransaction?.note || null)

    useEffect(() => {
        setSelectedNote(selectedTransaction?.note || null)
    }, [selectedTransaction?.note])

    const debouncedOnChange = useDebouncedCallback((note: string) => onChange(note), 500)

    const handleNoteChange = (note: string) => {
        setSelectedNote(note)
        debouncedOnChange(note)
    }
    
    return (
        <Textarea value={selectedNote || ''} onChange={(e) => handleNoteChange(e.target.value)} className="w-full h-24" />
    );
};

export { TransactionNotes };
